<template>
	<v-btn text small :color="btnColor" icon class="mr-1" v-if="allowIncognito" @click="toggleIncognito"><v-icon small>{{incognito ? 'mdi-incognito' : 'mdi-incognito-off' }}</v-icon></v-btn>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "IncognitoButton", 
		props: {
			room: {},
			incognito: {},
			btnColor: {type: String, default: "black"}
		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState({}),
			allowIncognito(){
				if( this.role !== "panelmember"){
					return true;
				}
				return false;
			},
			...Vuex.mapState({
				user: state => state.auth.user,
				role: state => state.auth.view, 
			})
		},
		methods: {
			toggleIncognito(){
				var data = {};
				if( this.incognito ){
					data = {
						incognito: false,
						audio: true, 
						video: true
					}
				}
				else{
					data = {
						incognito: true,
						audio: false, 
						video: false,
						screen: false
					}
				}
				this.$store.dispatch("updateDoc", {
					doc: `videoRooms/${this.room}/participants/${this.user.uid}`, 
					action: "update", 
					data: data 
				})
			},
		}
		// created(){
			
		// }

	}
// </script>"